/* TARJETA DE RESULTADO · para los cuestionarios que NO tienen tarjeta propia.
   Ann, 28-ago-2026: «que todos los cuestionarios que están activados y bien
   puntuados aparezcan en la ficha del paciente si los responde».

   El SF-12 y el ODI tienen tarjeta propia clonada de FisioVisión. Los demás no
   la tienen, y hacerles una a cada uno sería empezar de cero cada vez. Esta es
   una sola, que se adapta con lo que sabe de cada escala.

   🔴 LO QUE HACE QUE ESTO NO SEA PELIGROSO:
   Un número suelto no significa nada, y peor: significa cosas OPUESTAS según
   la escala.
        20 en el ODI    → muy bien   (menos es mejor)
        20 en el EVA    → dolor leve
        20 en el EFP-0  → muy mal    (más es mejor)
   Por eso cada escala trae escrito su máximo, su DIRECCIÓN y qué significa.
   Si un cuestionario no está en esta tabla NO SE PINTA — antes que enseñar un
   número que puede leerse al revés, no se enseña nada. */

const ESCALAS = {
  /* El EVA se queda AQUÍ escrito aunque la ficha no lo use: tiene su propia
     gráfica de evolución y pintarlo además sería duplicarlo. Se conserva por si
     algún día hace falta enseñarlo en otro sitio sin la línea. */
  vas_oficial: {
    titulo: 'Tu dolor', max: 100, sufijo: '', mejor: 'menos',
    pie: 'De 0 (sin dolor) a 100 (el peor imaginable).',
  },
  dolor_mefir: {
    titulo: 'Tu dolor por zonas', max: 10, sufijo: '', mejor: 'menos',
    pie: 'Media de las zonas que marcaste, de 0 a 10.',
  },
  efp0: {
    titulo: 'Tu estado funcional', max: 100, sufijo: '%', mejor: 'mas',
    pie: 'Equilibrio, fuerza y coordinación. Aquí, cuanto más alto, mejor.',
  },
  psfs: {
    titulo: 'Lo que puedes hacer', max: 10, sufijo: '', mejor: 'mas',
    pie: 'Las actividades que elegiste tú, de 0 a 10. Cuanto más alto, mejor.',
  },
};

function fechaCorta(iso) {
  try {
    return new Date(String(iso).slice(0, 10) + 'T00:00:00')
      .toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
  } catch (e) { return iso; }
}

/* serie = [{fecha, valor}] del episodio, de más antigua a más reciente */
export default function resultadoHTML(tipo, serie) {
  const E = ESCALAS[tipo];
  if (!E || !Array.isArray(serie) || !serie.length) return '';

  const hoy = serie[serie.length - 1];
  const ini = serie[0];
  const hayHistoria = serie.length > 1;

  // ¿va mejor? Depende de la dirección de LA ESCALA, no del signo del número.
  const dif = hayHistoria ? hoy.valor - ini.valor : 0;
  const mejora = E.mejor === 'menos' ? dif < 0 : dif > 0;
  const igual = dif === 0;

  const frase = !hayHistoria
    ? 'Este es tu punto de partida. La próxima vez podrás compararlo.'
    : igual ? 'De momento se mantiene igual. Tu fisio lo tiene en cuenta.'
      : mejora ? 'Vas mejorando desde que empezaste el tratamiento.'
        : 'Hoy ha sido un día más difícil. Tu fisio lo verá.';

  const pct = Math.max(0, Math.min(100, (Number(hoy.valor) / E.max) * 100));

  return (
    '<div class="fv-eq">' +
      '<div class="fv-eva__cab">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12h4l2-5 4 10 2-5h6"/></svg>' +
        '<div><b>' + E.titulo + '</b><small>Lo que contestaste el ' + fechaCorta(hoy.fecha) + '</small></div>' +
      '</div>' +
      '<p class="fv-eq__saludo">' + frase + '</p>' +

      (hayHistoria
        ? '<div class="fv-eq__antes">' +
            '<div><small>Al empezar</small><b>' + Math.round(ini.valor) + '<i>' + E.sufijo + '</i></b></div>' +
            '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h13M13 6l6 6-6 6"/></svg>' +
            '<div><small>Hoy</small><b class="' + (mejora ? 'es-mejor' : '') + '">' + Math.round(hoy.valor) + '<i>' + E.sufijo + '</i></b></div>' +
          '</div>'
        : '<div class="fv-eq__antes">' +
            '<div><small>Hoy</small><b>' + Math.round(hoy.valor) + '<i>' + E.sufijo + '</i></b></div>' +
          '</div>') +

      '<div class="fv-eq__caja">' +
        '<div class="fv-eq__barra"><i style="width:' + pct.toFixed(0) + '%"></i></div>' +
        '<small>' + E.pie + '</small>' +
      '</div>' +
    '</div>'
  );
}
